'use client';

import {useEnvConfig} from '@web-catalog/env';
import {useCallback, useState} from 'react';

import {YandexBannerAd} from '@web-catalog/components/Ads';

import styles from './AdWrapper.module.scss';

type Props = {
  position: number;
  className?: string;
  fallback?: React.ReactNode;
};

export const AdWrapper = ({position, fallback = null}: Props) => {
  const {YANDEX_ADS_APPS_LIST_BANNER_ID} = useEnvConfig();
  const [shouldShow, setShouldShow] = useState(true);
  const onRender = useCallback(() => setShouldShow(true), []);
  const onErrorOrNoAds = useCallback(() => setShouldShow(false), []);

  if (!shouldShow) {
    return fallback;
  }

  return (
    <li key={`ad-${position}`} className={styles.adListItem}>
      <YandexBannerAd
        bannerContainerClassName={styles.adPlaceholder}
        blockId={YANDEX_ADS_APPS_LIST_BANNER_ID}
        adType="sd_banner_catalog_apps"
        placement="apps_list"
        position={position}
        onRender={onRender}
        onError={onErrorOrNoAds}
        onNoAds={onErrorOrNoAds}
      />
    </li>
  );
};
